<div class="search-container" fxLayout="column" fxLayoutAlign="start stretch">
  <div *ngIf="selectedStudent && !searching; else showSelect" fxFlex="100" fxLayout="row" fxLayoutAlign="start start">
    <mat-card appearance="outlined" fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="start start">
        <app-profile-summary
          fxFlex="100"
          [thumbnailPhotoUrl]="selectedStudent.thumbnailPhotoUrl || getDefaultPhotoUrl()"
          [name]="selectedStudent.name"
          [email]="selectedStudent.primaryEmail"
          [ouPath]="selectedStudent.orgUnitPath"
        ></app-profile-summary>
        <div [matTooltip]="userEmail ? 'You may only clear the selected user when creating a new exception' : 'Clear the selected user'">
          <button mat-icon-button (click)="clearValue()" [disabled]="!!userEmail">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <ng-template #showSelect>
    <div *ngIf="userEmail && searching; else typeAhead" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px" fxFlexFill>
      <mat-progress-spinner mode="indeterminate" diameter="22"></mat-progress-spinner>
      <div>Loading info for {{userEmail}}</div>
    </div>
    <ng-template #typeAhead>
      <div [ngClass]="{'select-container': true, 'invalid': showRequired}" fxLayout="column" fxLayoutAlign="start stretch">
        <ng-select
          placeholder="Student search (Enter student name or student email)"
          [items]="students$ | async"
          [loading]="searching"
          [(ngModel)]="selectedStudent"
          [typeahead]="studentsSearchTerm$"
          (change)="onChange($event)"
          bindLabel="name"
          [multiple]="false"
          [closeOnSelect]="true"
          [clearable]="true"
          (clear)="clearValue()"
          notFoundText="No students found"
          appendTo="body"
          class="students"
          #ngSelectElement
        >

          <ng-template ng-option-tmp let-item="item">

            <div class="profile" fxLayout="row" fxLayoutAlign="start center">

              <app-profile-summary
                [thumbnailPhotoUrl]="item.thumbnailPhotoUrl || getDefaultPhotoUrl()"
                [name]="item.name"
                [email]="item.primaryEmail"
                [ouPath]="item.orgUnitPath"
              ></app-profile-summary>
              <!--        The inline style is required to override defaults for ng-select that don't respect the CSS rules defined-->
              <div *ngIf="item.schools.length" style="font-size:12px; line-height:12px;" fxFlex="50" fxLayout="column" fxLayoutAlign="start space-between">
                <div>Schools:</div>
                <p>{{getSchoolList(item.schools)}}</p>
              </div>

            </div>

          </ng-template>

          <ng-template ng-label-tmp let-item="item" let-clear="clear">

            <div class="profile" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
              <img height="15" width="15" class="profileImg mr-8" src="{{item.thumbnailPhotoUrl || getDefaultPhotoUrl()}}" alt="profile image"/>
              <span>{{item.name}}</span>
              <span class="ng-value-icon right" (click)="clear(item)">×</span>
            </div>

          </ng-template>

          <ng-template ng-typetosearch-tmp>
            <div class="ng-option disabled">
              Start typing...
            </div>
          </ng-template>

          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
              No users found for "{{searchTerm}}".
            </div>
          </ng-template>

          <ng-template ng-loadingtext-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
              Fetching users starting with "{{searchTerm}}"...
            </div>
          </ng-template>

        </ng-select>
        <mat-error *ngIf="showRequired">Required</mat-error>
      </div>
    </ng-template>
  </ng-template>
</div>
